import { DEFAULT_ROUTE } from 'utils/constants';
import { PermissionState } from 'utils/notifications';
import type { DesktopContent } from './content';

export type DeliveryChannel = 'desktop' | 'snackbar';

type NotificationConstructor = new (title: string, options?: ConstructorParameters<typeof Notification>[1]) => Notification;

type ShowDesktopNotificationParams = {
  NotificationCtor?: NotificationConstructor;
  content: DesktopContent;
  onClick: (notification: Notification, data: DesktopContent['data']) => void;
};

export function decideChannel({ supported, permission, visibilityState }: {
  supported: boolean;
  permission: PermissionState;
  visibilityState: string;
}): DeliveryChannel {
  return supported && permission === 'granted' && visibilityState === 'hidden' ? 'desktop' : 'snackbar';
}

export function showDesktopNotification({
  NotificationCtor = window.Notification,
  content,
  onClick,
}: ShowDesktopNotificationParams): boolean {
  try {
    const { title, body, icon, tag, data } = content;
    const notification = new NotificationCtor(title, { body, icon, tag, data });
    notification.onclick = () => onClick(notification, data);
    return true;
  } catch {
    return false;
  }
}

export function resolveOrderPath(orderId: string | undefined, tabs: { id: string }[]): string | null {
  if (!orderId || !tabs.some((tab) => tab.id === orderId)) {
    return null;
  }
  return `/orders/details/${orderId}/${DEFAULT_ROUTE}`;
}
